import React, { useEffect, useState } from "react";
import { selectCurrent } from '../redux/theme/selectors'
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { settings } from "../redux/settings/actions";
import * as R from "ramda"
import { uploadFiles } from "../redux/upload-files/action";
import { selectUploadFileCreatedItem, selectUploadFileQueryItems, selectUploadFilesListItems } from "../redux/upload-files/selector";
import { FaCamera, FaFile, FaVideo } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import _ from "lodash";
import TabContainer from "../common/components/tab/containers/tab.containers";
import storePersist from "../redux/storePersist";

let chosenFiles: any = []
export default function MobileUploadFiles({ handleClose, isSingleUpload, currentFilesSrc, folder, handleFilesSubmit, type, subFolder, ownerId }: any) {
    var tenantId = storePersist?.get("accessTokenMetadata")?.current?.TokenMetadata?.TenantId;
    const dispatch = useAppDispatch();
    const currentFile = useAppSelector(selectUploadFileCreatedItem)
    const queryFile = useAppSelector(selectUploadFileQueryItems)
    const listFiles = useAppSelector(selectUploadFilesListItems)

    const [
        selectedFileSRC,
        setSelectedFileSRC
    ] = useState<any>()


    const getFilesReady = (event: any) => {
        chosenFiles = []
        R.map(
            (file) => {
                chosenFiles.push(file);
                return file;
            },
            event.target.files
        )
    }
    const uploadChosenFiles = () => {
        const frmData = new FormData();

        frmData.append(
            'DigiiFolderName',
            folder
        )
        frmData.append(
            'DigiiDocTypeName',
            type
        )
        frmData.append(
            'SubFolderName',
            subFolder || ''
        )
        frmData.append(
            'OwnerId',
            ownerId || 0
        )
        frmData.append(
            'TenantId',
            tenantId || 0
        )
        R.map(
            (file) => {
                frmData.append(
                    'documents',
                    file
                );
                return file
            },
            chosenFiles
        )

        dispatch(uploadFiles.create({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dms/digii-docs`,
            entity: 'uploadFiles',
            jsonData:
                frmData


        })).then(() => {

            if (isSingleUpload) {
                fetchFile(currentFile?.result)
            } else {
                fetchFiles();
            }
        })
        chosenFiles = [];


    }

    const fetchFile = async (id: any) => {
        dispatch(uploadFiles.query({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api//v6.0/dms/digii-docs/query`,
            entity: 'uploadFiles',
            jsonData: {
                Records: [{
                    Context: {},
                    Message: {
                        TenantId: tenantId,
                        Id: id
                    }
                }

                ]
            }
        }))

        setSelectedFileSRC(queryFile?.result?.items?.DocumentPath)
    }
    const fetchFiles = async () => {
        dispatch(uploadFiles.list({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dms/digii-docs/query-by-digiifolder`,
            entity: 'uploadFiles',
            jsonData: {
                Records: [{
                    Context: {},
                    Message: {
                        TenantId: tenantId,
                        OwnerId: ownerId,
                        DigiiFolderName: folder,
                        DigiiDocTypeName: type,
                        SubFolderName: ''
                    }
                }

                ]
            }
        }))


    }

    const onSubmit = () => {

        handleFilesSubmit(selectedFileSRC);
        handleClose()
    }
    const setSelectedFileSrc = (fileSrc: any) => {
        setSelectedFileSRC(fileSrc)
    }

    useEffect(
        () => {
            setSelectedFileSRC(currentFilesSrc)
        },
        []
    )

    useEffect(
        () => {
            if (!isSingleUpload && folder) {
                setTimeout(() => {
                    fetchFiles();
                })
            }
        },
        [folder]
    )
    const deleteUploadFile = async (item: any) => {

        dispatch(uploadFiles.delete({
            url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dms/digii-docs/delete`,
            entity: 'uploadFiles',
            jsonData: {
                Records: [{
                    Context: {},
                    Message: {
                        TenantId: tenantId,
                        Id: item?.Id
                    }
                }

                ]
            }
        })).then(() => {
            fetchFiles()
        })



    }
    const imageTabItems = [
        {
            id: 1,
            title: 'Upload File',
            component: (
                <>
                    {listFiles?.result?.items
                        ? <div className="flex flex-wrap sm:flex-nowrap overflow-auto gap-4">
                            {_.map(listFiles?.result?.items, (file: any, index: any) => (
                                <div
                                    key={index}
                                    onClick={() => setSelectedFileSrc(file?.DocumentPath)}
                                    className="flex flex-col items-center w-32 cursor-pointer"
                                >
                                    <img
                                        alt="Product Image"
                                        src={file?.DocumentPath}
                                        className=" object-cover rounded h-24 w-24"
                                    />
                                    <div className="text-center text-sm mt-1">{file?.DocumentName}</div>
                                    {file && (
                                        <div onClick={() => deleteUploadFile(file)} className="mt-1">
                                            <MdDelete className="text-red-600 text-xl" />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                        : null}
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 mt-2 mb-2">
                        <input
                            accept="image/*"
                            id="icon-button-file"
                            multiple={!isSingleUpload}
                            onChange={(event) => { getFilesReady(event); }}
                            type="file"
                            className="w-full sm:w-auto text-sm"
                        />

                        <button
                            onClick={uploadChosenFiles}
                            className="border border-[#2A4574] text-[#2A4574] px-4 py-2 text-sm font-medium rounded hover:bg-[#2A4574] hover:text-white transition"
                        >
                            Upload
                        </button>
                    </div>
                </>

            ),
            isVisible: true,
        },
        {
            id: 2,
            title: 'Add Url',
            component: (
                <div>
                    <textarea
                        id="outlined-multiline-static"

                        onChange={(event) => { setSelectedFileSRC(event.target.value); }}
                        rows={4}
                        style={{ width: '100%' }}
                        value={selectedFileSRC}


                    />
                    <div style={{ color: 'red' }}>
                        <u>Note:</u> The file present in the given URL is
                        not
                        stored in
                        the
                        application.
                    </div>
                </div>
            ),
            isVisible: true,
        },
    ]
    const videoTabItems = [
        {
            id: 1,
            title: 'Upload File',
            component: (
                <>
                    {listFiles?.result?.items
                        ? <div className=" flex overflow-auto">
                            {_.map(
                                listFiles?.result?.items,
                                (file: any, index: any) => (
                                    <div
                                        onClick={() => { setSelectedFileSrc(file?.DocumentPath); }}
                                        style={{ margin: 1, textAlign: 'center', cursor: 'pointer' }}
                                    >
                                        <video

                                            src={file?.DocumentPath}
                                            className=" w-32"
                                        />
                                        <div className=" text-center ml-auto text-sm">{file?.DocumentName}</div>
                                        {file
                                            ? <div onClick={() => deleteUploadFile(file)}>
                                                <MdDelete className=" text-red-600" />

                                            </div>
                                            : <></>}
                                    </div>
                                )
                            )}
                        </div>
                        : null}
                    <div style={{ display: 'flex', justifyContent: 'start', marginTop: 3, marginBottom: 3 }}>
                        <input
                            accept="video/*"
                            id="icon-button-file"
                            multiple={!isSingleUpload}
                            onChange={(event) => { getFilesReady(event); }}
                            type="file"
                        />

                        <button onClick={uploadChosenFiles} className="border-x border-y border-[#2A4574] text-[#2A4574] px-2 py-1 text-sm font-light">
                            Upload
                        </button>
                    </div>
                </>

            ),
            isVisible: true,
        },
        {
            id: 2,
            title: 'Add Url',
            component: (
                <div>
                    <textarea
                        id="outlined-multiline-static"

                        onChange={(event) => { setSelectedFileSRC(event.target.value); }}
                        rows={4}
                        style={{ width: '100%' }}
                        value={selectedFileSRC}


                    />
                    <div style={{ color: 'red' }}>
                        <u>Note:</u> The file present in the given URL is
                        not
                        stored in
                        the
                        application.
                    </div>
                </div>
            ),
            isVisible: true,
        },
    ]
    const documentTabItems = [
        {
            id: 1,
            title: 'Upload File',
            component: (
                <>
                    {listFiles?.result?.items
                        ? <div className=" flex overflow-auto">
                            {_.map(
                                listFiles?.result?.items,
                                (file: any, index: any) => (
                                    <div
                                        onClick={() => { setSelectedFileSrc(file?.DocumentPath); }}
                                        style={{ margin: 1, textAlign: 'center', cursor: 'pointer' }}
                                    >

                                        <div className=" text-center ml-auto text-sm" >{file?.DocumentName}</div>
                                        {file
                                            ? <div onClick={() => deleteUploadFile(file)}>
                                                <MdDelete className=" text-red-600" />

                                            </div>
                                            : <></>}
                                    </div>
                                )
                            )}
                        </div>
                        : null}
                    <div style={{ display: 'flex', justifyContent: 'start', marginTop: 3, marginBottom: 3 }}>
                        <input
                            accept="file/*"
                            id="icon-button-file"
                            multiple={!isSingleUpload}
                            onChange={(event) => { getFilesReady(event); }}
                            type="file"
                        />

                        <button onClick={uploadChosenFiles} className="border-x border-y border-[#2A4574] text-[#2A4574] px-2 py-1 text-sm font-light">
                            Upload
                        </button>
                    </div>
                </>

            ),
            isVisible: true,
        },
        {
            id: 2,
            title: 'Add Url',
            component: (
                <div>
                    <textarea
                        id="outlined-multiline-static"

                        onChange={(event) => { setSelectedFileSRC(event.target.value); }}
                        rows={4}
                        style={{ width: '100%' }}
                        value={selectedFileSRC}


                    />
                    <div style={{ color: 'red' }}>
                        <u>Note:</u> The file present in the given URL is
                        not
                        stored in
                        the
                        application.
                    </div>
                </div>
            ),
            isVisible: true,
        },
    ]
    return (
        <>
            {type && (
                <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-30">
                    <div className="bg-white rounded-lg shadow-lg w-[90vw] max-w-3xl max-h-[60vh] flex flex-col">

                        {/* Sticky Header */}
                        <div className="sticky top-0 bg-white z-10 border-b pb-2 mb-2 px-4 pt-4 flex items-start justify-between">
                            <h2 className="text-lg font-semibold">Upload Files</h2>
                            <button onClick={handleClose} className="text-gray-500 hover:text-gray-800">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-x-circle"
                                >
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="m15 9-6 6" />
                                    <path d="m9 9 6 6" />
                                </svg>
                            </button>
                        </div>

                        {/* modal body */}
                        <div className="overflow-auto px-4 scrollbar-hide" style={{ maxHeight: 'calc(80vh - 120px)' }}>
                            <div className="p-2">
                                <div className="flex w-full flex-col items-start justify-between text-md" >
                                    Current File
                                </div>
                                <div>
                                    {type === 'image' &&
                                        <>
                                            <div className=" flex overflow-auto">
                                                {currentFilesSrc
                                                    ? <div
                                                        onClick={() => { setSelectedFileSrc(currentFilesSrc); }}
                                                        style={{ margin: 1, textAlign: 'center', cursor: 'pointer' }}
                                                    >
                                                        <img

                                                            src={currentFilesSrc}
                                                            className="h-20 w-48"
                                                        />
                                                    </div>
                                                    : null}
                                            </div>
                                        </>}
                                    {type === 'video' && <>
                                        <>
                                            <div className=" flex overflow-auto">
                                                {currentFilesSrc
                                                    ? <div
                                                        onClick={() => { setSelectedFileSrc(currentFilesSrc); }}
                                                        style={{ margin: 1, textAlign: 'center', cursor: 'pointer' }}
                                                    >

                                                        <h3><FaVideo /></h3>
                                                        <div style={{ textAlign: 'center', wordBreak: 'break-word' }}>{currentFilesSrc}</div>
                                                    </div>
                                                    : null}
                                            </div>
                                        </>
                                    </>}
                                    {type === 'document' && <>
                                        <div className=" flex overflow-auto">
                                            {currentFilesSrc
                                                ? <div
                                                    onClick={() => { setSelectedFileSrc(currentFilesSrc); }}
                                                    style={{ margin: 1, textAlign: 'center', cursor: 'pointer' }}
                                                >
                                                    <h3><FaFile /></h3>
                                                    <div style={{ textAlign: 'center', wordBreak: 'break-word' }}>{currentFilesSrc}</div>
                                                </div>
                                                : null}
                                        </div>

                                    </>}
                                </div>
                                {!currentFilesSrc && <div style={{ color: '#2B60E9' }}>
                                    No file selected
                                </div>}


                            </div>
                            <div className="p-2">
                                {type === 'image' &&
                                    <>
                                        {selectedFileSRC && <div >
                                            <img
                                                alt="Product Image"
                                                src={selectedFileSRC}
                                                className=" w-20 h-20 "
                                            />
                                        </div>}

                                        {!selectedFileSRC &&
                                            <div
                                                className=" justify-center items-center flex w-auto"
                                            //style={{ height: 100, justifyContent: 'center', display: 'flex', width: 100 }}
                                            >
                                                <h5 style={{ alignSelf: 'center', color: '#2B60E9', fontWeight: 700 }}>
                                                    No file selected
                                                </h5>
                                            </div>}
                                        <TabContainer tabItems={imageTabItems} />
                                    </>}

                                {type === 'video' &&
                                    <>
                                        <div >
                                            {selectedFileSRC
                                                ? <video
                                                    autoPlay
                                                    controls
                                                    loop
                                                    muted
                                                    preload="auto"
                                                    src={selectedFileSRC}
                                                />
                                                : null}

                                            {!selectedFileSRC &&
                                                <div

                                                    style={{ height: 100, justifyContent: 'center', display: 'flex', width: 100 }}
                                                >
                                                    <h5 style={{ alignSelf: 'center', color: '#2B60E9', fontWeight: 700 }}>
                                                        No file selected
                                                    </h5>
                                                </div>}
                                        </div>

                                        <TabContainer tabItems={videoTabItems} />
                                    </>}

                                {type === 'document' &&
                                    <>
                                        <div >
                                            {selectedFileSRC
                                                ? <iframe
                                                    src={selectedFileSRC}
                                                    title="Document"
                                                />
                                                : null}
                                            {!selectedFileSRC &&
                                                <div

                                                    style={{ height: 100, justifyContent: 'center', display: 'flex', width: 100 }}
                                                >
                                                    <h5 style={{ alignSelf: 'center', color: '#2B60E9', fontWeight: 700 }}>
                                                        No file selected
                                                    </h5>
                                                </div>}
                                        </div>

                                        <TabContainer tabItems={documentTabItems} />
                                    </>}
                            </div>
                        </div>

                        {/* Footer buttons */}
                        <div className="sticky bottom-0 bg-white z-10 px-4 py-3 mt-auto border-t flex justify-end">
                            <button
                                onClick={onSubmit}
                                className="border border-[#2A4574] text-[#2A4574] px-4 py-2 text-sm rounded"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>


    );
}